import moment from 'moment';
import isNumber from 'lodash/isNumber';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import memoize from 'lodash/memoize';
import debounce from 'lodash/debounce';
import {DEFAULT_STEM_IMG, DEFAULT_STEM_LOCATION, instruments} from '../constants/constants';
import {AttachmentType, ProjectAssetsType} from '../constants/enums';

/**
 * Generate Uuid
 * @returns {string}
 */
export function generateUuid(){
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let cryptoObj = window.crypto || window.msCrypto; //IE Support
	    let r = cryptoObj.getRandomValues(new Uint8Array(1))[0] % 16 | 0,
            v = (c === 'x') ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
    });
}

/**
 * Generate a GUID
 * @returns {string}
 */
export function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}


/**
 * Checks if a number is odd or not
 * @param num   {Number}    The number to check
 * @returns {Number}
 */
export function isEven(num) {
    return num % 2;
}

/**
 * Convert seconds to minutes
 * @param time
 * @param format
 * @returns {*}
 */
export function secondsToMinutes(time, format){
    if(isNumber(time)) {
        return moment().startOf('day').seconds(time).format(format)
    }
}

/**
 * Convert seconds to minutes
 * @param date
 * @returns {String}    Formated date time string
 */
export function getDateTimeString(date){
    let formatDate = moment(date);
    if(moment(date).isValid()) {
        return `${formatDate.format('L')} ${formatDate.format('LT')}`;
    }
    return '';
}

export function getDateString(date){
    let formatDate = moment(date);
    if(moment(date).isValid()) {
        return `${formatDate.format('L')}`;
    }
    return '';
}

/**
 * Convert seconds fraction to milliseconds (3 decimal places + padding)
 * @param time - time in seconds
 * @returns {*}
 */
export function secondsToMilliseconds(time){
    if(isNumber(time)) {
        return Math.floor((time - Math.floor(time)) * 10);
    }
}



export function getDevice(){
        var ua= navigator.userAgent, tem,
            M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE '+(tem[1] || '');
        }
        if(M[1]=== 'Chrome'){
            tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
            if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        tem= ua.match(/version\/(\d+)/i);
        if(tem !== null) M.splice(1, 1, tem[1]);
        return M.join(' ');
}

/**
 * Capitalize string
 * @param string    {String}    The string to capitalize
 * @returns {string}
 */
export function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Un Capitalize string
 * @param string    {String}    The string to uncapitalize
 * @returns {string}
 */
export function unCapitalize(string) {
    if(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    }
}

export function getImageByInstrument(instrumentsList: Array<Object>) {
    if (isEmpty(instrumentsList)) {
        return DEFAULT_STEM_IMG;
    }

    const firstInstrument = instrumentsList[0];
    const instrumentObject = instruments.find(inst=>inst.name === firstInstrument.name);

    if (instrumentObject) {
        return `${DEFAULT_STEM_LOCATION}/${instrumentObject.image}`;
    }
    return DEFAULT_STEM_IMG;
}


/**
 * Delays a until a timeout is set
 * @param timeout   {Number}    Timeout duration in seconds to delay
 * @returns {Promise}
 */
export function delay(timeout){
    return new Promise(resolve=>setTimeout(()=>resolve(),timeout));
}

/**
 * Split underscore into a space and capitalize the first letter
 * @param key   {String}    Key to process
 * @returns {string}
 */
export function keyToTitle(key){
    return capitalize(key.split('_').join(' '))
}

/**
 * [toCamelCase create cameCase out of string]
 * @param  {[type]} str [description]
 * @return {[type]}     [description]
 */
export function toCamelCase(str){
    str = str.split('-').join(' ');
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
        if (+match === 0) {
            return '';
        }
        return match.toUpperCase();
    });
}


/**
 * Turn camel case to string
 * @param str
 * @returns {XML|string}
 */
export function camelCaseToString(str){
    return str.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); })
}

/**
 * Get the youtube url id
 * @param src
 * @returns {*}
 */
export function getYoutubeUrlId(src){
    /* eslint-disable */
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    /* eslint-enable */
    var match = src.match(regExp);

    if (match && match[2].length === 11) {
        return match[2];
    } else {
        return 'error';
    }

}

/**
 * Return a random value from an array
 * @param array {Array} The array to traverse
 * @returns {*} Random array item
 */
export function rand(array){
    return array[Math.floor(Math.random() * array.length)];
}

/**
 * Compare diff between two flat arrays
 * @param arr1  {Array} Lead array
 * @param arr2  {Array} Comparable Array
 */
export function arrayDiff(arr1, arr2) {
    return arr1.filter((item) =>  arr2.indexOf(item) < 0);
}

/**
 * Check if flat arrays are different
 * @param arr1  {Array} Lead array
 * @param arr2  {Array} Comparable Array
 */
export function arrayIsEqual(arr1, arr2) {
    return isEmpty(arrayDiff(arr1, arr2));
}

/**
 * return a formated string for the array range
 * @param arr  {Array} the received flat array
 */
export function getRangeString(arr) {
    return `[${Math.floor(Math.min(...arr))}-${Math.ceil(Math.max(...arr))}]`;
}

/**
 * turn object array into a flat array
 * @param objectArray  {Array} Lead array
 * @param field  {String} field to keep
 */
export function toFlatArray(objectArray=[], field) {
    if(!isEmpty(objectArray) && !isUndefined(field)) {
        return objectArray.map(item => item[field]);
    }
}

/**
 * Perform the number truncate functionality
 * @param number    {Number}    The number to truncate
 * @returns {number}
 */
export function truncate(number) {
    return number > 0 ? Math.floor(number) : Math.ceil(number);
}

/**
 * get file file url from the file object
 * @param file
 * @returns {Promise<any>}
 */
export function getFileUrl(file){
    return new Promise(resolve => {
        let reader = new FileReader();
        reader.onload = (event) => {
            resolve(event.target.result);
        };
        reader.onerror = function(error) {
            console.log(error);
        };
        reader.readAsDataURL(file);
    });
}

/**
 * Find index of item in array
 * @param arr
 * @param val
 * @param findBy
 * @returns {Number || Undefined}
 */
export function findIndex(arr, val, findBy){
    if(!findBy){
        return arr.indexOf(val) > -1 ?arr.indexOf(val):undefined;
    }
    return arr.findIndex(i => i[findBy] === val[findBy]) > -1 ?arr.findIndex(i => i[findBy] === val[findBy]):undefined;
}

export function isScrolledIntoView(el) {
    let rect = el.getBoundingClientRect();
    let elemTop = rect.top;
    let elemBottom = rect.bottom;
    return  (elemTop >= 0) && (elemBottom <= window.innerHeight);

}

export function ellipsisString(string, offset) {
    return string && string.length > offset ? string.substring(0, offset).concat('...') : string;
}

export function html2str(htmlString) {
    return htmlString ? decodeHTML(htmlString.replace(/<\/p>/ig, ' ').replace(/(<([^>]+)>)/ig, '')) : '';
}

const decodeHTML = (html) => {
    let temp = document.createElement('textarea');
    temp.innerHTML = html;
    let result = temp.value;
    temp.remove();
    return result;
}

export const getAttachmentUrl = (attachment) => {
    return attachment.url ? `${attachment.url}` : `/attachments/${attachment.id}`;
};


export function memoizeDebounce(func, wait=0, options={}) {
    let mem = memoize(function(a,b,c) {
        return debounce(func, wait, options)
    });
    return function(a,b,c){mem(a,b,c)(a,b,c)}
}

export function attachedTypeFile(file) {
    if (/^image\//i.test(file.type) || /\.(gif|jpe?g|tiff|png|svg)$/i.test(file.name)) return AttachmentType.Image;
    if (file.type === 'application/pdf' || /\.pdf$/i.test(file.name)) return AttachmentType.Pdf;
    if (/\.docx?$/i.test(file.name)) return AttachmentType.Doc;
    if (/\.(cho|chordpro|crd|pro)$/i.test(file.name)) return AttachmentType.ChordPro;
    if (/\.(music)?x?mx?l/i.test(file.name) || (file.type && file.type.includes('xml'))) return AttachmentType.Xml;
    return null;
}

// Get and Set CSS Variable
export const setCssVar = (name, value) => {
    if (name.substr(0, 2) !== '--') {
        name = `--${name}`;
    }
    if (value) {
        document.documentElement.style.setProperty(name, value);
    }
    return getComputedStyle(document.documentElement).getPropertyValue(name);
};

export function getPracticeTimeString(seconds, format) {
    return moment.utc(moment.duration(seconds,"s").asMilliseconds()).format(format || "HH:mm");
}

export function isNotationXml(type) {
    return type !== 'application/pdf' && type !== '.pdf' && type !== '.doc' && type !== '.docx' && type !== 'application/msword' && type?.indexOf('image/') < 0;
}

export function checkFileExtension(fileName) {
    return /^.+\.([^.]+)$/.test(fileName);
}

export function getAssestTypeName(type) {
    switch (type) {
        case ProjectAssetsType.Text:
            return 'Text';
        case ProjectAssetsType.Notation:
            return 'Notation';
        case ProjectAssetsType.Audio:
            return 'Audio';
        case ProjectAssetsType.Video:
            return 'Video';
        case ProjectAssetsType.Image:
            return 'Image';
        default:
            return null;
    }
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function convertFileType(file) {
    if (!file || !file.type) {
        return AttachmentType.Unknown;
    }
    let type = file.type.split("/");
    if (type[0] === 'image') {
        type = AttachmentType.Image;
    } else {
        type = type[type.length - 1];
    }
    return type;
}


export function getClientXY(e) {
    let clientX, clientY;
    if (e.clientX) {
        clientX = e.clientX;
        clientY = e.clientY;
    } else {
        if (e.changedTouches && e.changedTouches.length > 0) {
            clientX = e.changedTouches[0].clientX;
            clientY = e.changedTouches[0].clientY;
        }
    }

    return {clientX, clientY};
}

export function dist(touch1, touch2) {
    if (!touch1 || !touch2) {
        return Number.MAX_SAFE_INTEGER;
    }
    return Math.sqrt(Math.pow(touch1.clientX - touch2.clientX, 2) + Math.pow(touch1.clientY - touch2.clientY, 2))
}

export function makeS3mediaUrl(folderArray = [], fileName, fileType) {
    return `url(/media/${folderArray.join('/')}/${fileName}.${fileType ? fileType : 'jpg'})`
}